import React, { useState, useEffect } from 'react';
import api from '../services/api';

interface Service {
  id: number;
  name_ar: string;
  name_en: string;
  slug: string;
  icon: string | null;
  description: string | null;
}

const serviceEmojis: Record<string, string> = {
  veterinary: '🏥',
  transport: '🚛',
  feed: '🌾',
  shearing: '✂️',
  breeding: '🧬',
  slaughter: '🔪',
};

const ServicesPage: React.FC = () => {
  const [services, setServices] = useState<Service[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/services').then((res) => {
      setServices(res.data.data || []);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="max-w-site mx-auto px-4 py-20 text-center">
        <p className="text-gray-400">جاري التحميل...</p>
      </div>
    );
  }

  return (
    <div className="max-w-site mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold text-gray-800 mb-2">الخدمات</h1>
      <p className="text-gray-500 text-sm mb-6">خدمات متنوعة للمواشي والحلال</p>

      {services.length === 0 ? (
        <div className="bg-white rounded-xl p-12 text-center shadow-sm">
          <p className="text-gray-400">لا توجد خدمات حالياً</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {services.map((service) => (
            <div key={service.id} className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition">
              <div className="text-4xl mb-4">{serviceEmojis[service.slug] || '🔧'}</div>
              <h3 className="font-bold text-gray-800 text-lg mb-1">{service.name_ar}</h3>
              <p className="text-xs text-gray-400 mb-2">{service.name_en}</p>
              {service.description && (
                <p className="text-sm text-gray-500 leading-relaxed">{service.description}</p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ServicesPage;
